document.addEventListener('DOMContentLoaded', () => {
  // Fallbacks: se usan si el setting del customizer está vacío o inválido
  const DEFAULT_GDPR_COUNTRIES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE',
    'IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB'
  ];

  const DEFAULT_EU_EEA_COUNTRIES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE',
    'IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE',
    'IS','LI','NO'
  ];

  // Acepta comas, espacios, saltos de línea o punto y coma como separador
  const parseCountryList = (raw, fallback, label) => {
    const codes = Array.from(
      new Set(
        String(raw || '')
          .toUpperCase()
          .split(/[^A-Z]+/)
          .filter((code) => code.length === 2)
      )
    );

    if (!codes.length) {
      console.warn(`[GEO DEBUG] ${label} setting empty or invalid, using default list`);
      return fallback;
    }

    return codes;
  };

  const gdprCountries = parseCountryList(
    window.__gdprCountries,
    DEFAULT_GDPR_COUNTRIES,
    'GDPR countries'
  );

  const euEeaCountries = parseCountryList(
    window.__euEeaCountries,
    DEFAULT_EU_EEA_COUNTRIES,
    'EU/EEA countries'
  );

  console.log('[GEO DEBUG] GDPR list:', gdprCountries.join(','));
  console.log('[GEO DEBUG] EU/EEA list:', euEeaCountries.join(','));

  // Normaliza un pathname: minúsculas, sin slash final, sin prefijo de locale (/fr, /fr-ca)
  const normalizePath = (pathname) =>
    pathname
      .replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '')
      .replace(/\/+$/, '')
      .toLowerCase() || '/';

  const isOnWithdrawalPage = (url) => {
    if (!url) return false;
    try {
      const target = new URL(url, window.location.origin);
      if (target.origin !== window.location.origin) return false;
      return normalizePath(target.pathname) === normalizePath(window.location.pathname);
    } catch (err) {
      console.warn('[GEO DEBUG] Invalid withdrawalFormUrl:', url, err);
      return false;
    }
  };

  const injectWithdrawalLink = (url) => {
    // Evita duplicados si el script corre dos veces
    if (document.getElementById('eu-withdrawal-item')) return true;

    const termsLink = Array.from(document.querySelectorAll('.Linklist a')).find(
      (a) =>
        /terms[-_]?(and[-_]?)?conditions/i.test(a.getAttribute('href') || '') ||
        /terms\s*&\s*conditions/i.test(a.textContent.trim())
    );

    if (!termsLink) {
      console.log('[GEO DEBUG] Terms & Conditions link not found yet');
      return false;
    }

    const termsItem = termsLink.closest('li');

    const item = document.createElement('li');
    item.id = 'eu-withdrawal-item';
    item.className = termsItem ? termsItem.className : 'Linklist__Item';

    const link = document.createElement('a');
    link.href = url;
    link.textContent = 'Withdraw from contract';
    link.className = termsLink.className; // hereda los estilos del tema

    item.appendChild(link);

    if (termsItem) {
      termsItem.insertAdjacentElement('afterend', item);
    } else {
      termsLink.closest('ul').appendChild(item);
    }

    console.log('[GEO DEBUG] Link injected after Terms & Conditions');
    return true;
  };

  const injectWhenReady = (url, attempts = 20) => {
    if (injectWithdrawalLink(url)) return;
    if (attempts > 0) {
      setTimeout(() => injectWhenReady(url, attempts - 1), 250);
    } else {
      console.warn('[GEO DEBUG] Gave up waiting for footer Linklist');
    }
  };

  const loadTrueVault = () => {
    const truevault = document.createElement('script');
    truevault.src = 'https://polaris.truevaultcdn.com/static/pc/J3CGT47II/polaris.js';
    truevault.defer = true;
    document.head.appendChild(truevault);
  };

  console.log('[GEO DEBUG] Script loaded, fetching country...');

  fetch('https://get.geojs.io/v1/ip/country.json')
    .then((response) => response.json())
    .then((data) => {
      const country = data.country;
      const withdrawalUrl = window.__withdrawalFormUrl;
      const isEuEea = euEeaCountries.includes(country);
      const isGdpr = gdprCountries.includes(country);

      console.log('[GEO DEBUG] Country detected:', country);
      console.log('[GEO DEBUG] Is EU/EEA:', isEuEea, '| Is GDPR:', isGdpr);
      console.log('[GEO DEBUG] withdrawalUrl:', withdrawalUrl);

      // Bloqueo de acceso: país fuera de GDPR y EU/EEA en la página de retractación
      if (!isGdpr && !isEuEea && isOnWithdrawalPage(withdrawalUrl)) {
        console.log('[GEO DEBUG] Non-EU visitor on withdrawal page, redirecting home');
        window.location.replace('/');
        return;
      }

      if (isGdpr) loadTrueVault();

      if (isEuEea && withdrawalUrl) {
        injectWhenReady(withdrawalUrl);
      } else {
        console.log('[GEO DEBUG] Skipped injection. EU/EEA:', isEuEea, '| URL:', !!withdrawalUrl);
      }
    })
    .catch((err) => {
      // Fail-open: sin país conocido no redirigimos, para no bloquear usuarios EU
      console.error('[GEO DEBUG] Fetch failed:', err);
      loadTrueVault();
    });
});